import { forwardRef, createElement } from 'react';

function IconBooking(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M19.25 2a.75.75 0 01.743.648L20 2.75v18.5a.75.75 0 01-.648.743L19.25 22H6.75a2.75 2.75 0 01-2.739-3H4V5l.043.001A.749.749 0 014 4.75a2.75 2.75 0 012.582-2.745L6.75 2h12.5zm-.75 16H6.75a1.25 1.25 0 00-.128 2.494l.128.006H18.5v-.75H6.75a.5.5 0 110-1H18.5V18zM5.506 4.622L5.5 4.75a.749.749 0 01-.043.251L5.5 5v11.8a2.732 2.732 0 011-.289V3.525a1.25 1.25 0 00-.994 1.097zM18.5 3.5h-11v13h11v-13zM14.25 9a.75.75 0 110 1.5h-2.5a.75.75 0 110-1.5h2.5zm2-3a.75.75 0 110 1.5h-6.5a.75.75 0 010-1.5h6.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Booking = /*#__PURE__*/forwardRef(IconBooking);

export default Booking;
//# sourceMappingURL=Booking.js.map
